module.exports = __webpack_public_path__ + "static/media/citi_logo.d7009f38.png";